// extracted by mini-css-extract-plugin
module.exports = {"root":"NoData_root__35zyR"};